/*
 *
 * Viewer actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { PositionAngle } from 'lib/modelBuilder/constants';

export const openDoorsAction = (value: number, positions?: PositionAngle[]) =>
  action(ActionTypes.OPEN_DOORS, { value, positions });

export const displayMarkingAction = () => action(ActionTypes.DISPLAY_MARKING);

export const furnitureDisplayedAction = () =>
  action(ActionTypes.FURNITURE_DISPLAYED);

export const cabinetDisplayedAction = () =>
  action(ActionTypes.CABINET_DISPLAYED);
